import React from 'react'

export const TerminalButtons: React.FunctionComponent = () => (
  <div className='terminal-header-buttons-container'>
    <div className="terminal-header-button red" />
    <div className="terminal-header-button yellow" />
    <div className="terminal-header-button green" />
  </div>
)